@if (control) {
  @if (!disabled) {
    <div class="html-editor-container">
      <button (click)="onPreview()">
        <mat-icon>open_in_new</mat-icon>
      </button>
      <textarea class="custom-scroll" [ariaLabel]="label" #area [formControl]="control" [readonly]="disabled" (beforeinput)="onBeforeInput($event)"></textarea>
    </div>
  } @else {
    <app-template-html [control]="control" [value]="value" />
  }
}
